<template>
	<button class="flex items-center flex-wrap" :class="{'btn-disabled': $store.getters.isLoading || disabled}" @click="buttonClicked" :disabled="$store.getters.isLoading || disabled">
		<slot></slot>
		<!-- <transition name="zoom">
			<div class="spinner" v-if="$store.getters.isLoading">
				<div class="bounce1"></div>
				<div class="bounce2"></div>
				<div class="bounce3"></div>
			</div>
		</transition> -->
	</button>
</template>

<script>
export default {
	props: {
		'text' : String,
		'disabled' : {
			default: false
		}
	},
	name: 'ActionButton',

	data () {
		return {

		}
	},
	methods: {
		buttonClicked: function (e) {
			this.$emit('button-clicked', e)
		}
	}
}
</script>

<style lang="css" scoped>
.spinner {
	@apply mr-2;
}

.spinner > div {
	@apply inline-block rounded-full w-2 h-2 bg-white;
	-webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
	animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
	-webkit-animation-delay: -0.32s;
	animation-delay: -0.32s;
}

.spinner .bounce2 {
	-webkit-animation-delay: -0.16s;
	animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
	0%, 80%, 100% { -webkit-transform: scale(0) }
	40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
	0%, 80%, 100% {
		-webkit-transform: scale(0);
		transform: scale(0);
		} 40% {
			-webkit-transform: scale(1.0);
			transform: scale(1.0);
		}
	}
</style>
